<sc-dialog-title>
    {{'make your selection' | translate: ['tmc-yard.dialog.transport-option.title', translationService.language]}}
</sc-dialog-title>
<sc-separator-line></sc-separator-line>
<sc-padding>
    <div class="content no-field-space">
        <sc-flex [fitHeight]="true" [stretchContent]="true">
            <sc-flex-fitting-content>
                <sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">
                    <sc-sub-title>{{'selected values' | translate: ['tmc-yard.dialog.transport-option.selected-title',
                        translationService.language]}}</sc-sub-title>
                    <sc-content-spacer [vertical]="true"></sc-content-spacer>
                    <sc-flex-fitting-content [vertical]="true">
                      <sc-scroll-pane>
                          <ng-container *ngFor="let value of selectedValues; let i = index">
                              <sc-content-spacer [half]="true" [vertical]="true" *ngIf="i>0"></sc-content-spacer>
                              <sc-data-set-tile [light]="i % 2 === 0">
                                  <sc-padding>
                                      <sc-flex >
                                          {{value.label}}
                                          <sc-content-spacer [grow]="true"></sc-content-spacer>
                                          <sc-action-icon iconClass="fa-minus" (click)="remove(value)"></sc-action-icon>
                                      </sc-flex>
                                  </sc-padding>
                              </sc-data-set-tile>
                          </ng-container>
                      </sc-scroll-pane>
                    </sc-flex-fitting-content>
                </sc-flex>
            </sc-flex-fitting-content>
            <sc-content-spacer></sc-content-spacer>
            <sc-flex-fitting-content>
                <sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">
                    <sc-sub-title>{{'available values' | translate: ['tmc-yard.dialog.transport-option.available-title',
                        translationService.language]}}</sc-sub-title>
                    <sc-content-spacer [vertical]="true"></sc-content-spacer>
                    <form [formGroup]="formGroup">
                        <sc-flex >
                            <sc-string-field formControlName="query" [grow]="true" label="Suche"></sc-string-field>
                        </sc-flex>
                    </form>
                    <sc-content-spacer [vertical]="true"></sc-content-spacer>
                    <sc-flex-fitting-content [vertical]="true">
                      <sc-scroll-pane>
                          <ng-container *ngFor="let value of filteredValues; let i = index">
                              <sc-content-spacer [half]="true" [vertical]="true" *ngIf="i>0"></sc-content-spacer>
                              <sc-data-set-tile [light]="i % 2 === 0">
                                  <sc-padding>
                                      <sc-flex >
                                          <sc-action-icon iconClass="fa-plus" (click)="add(value)" *ngIf="!value.assigned"></sc-action-icon>
                                          <sc-icon iconClass="fa-square-check"  *ngIf="value.assigned"></sc-icon>
                                          <sc-content-spacer></sc-content-spacer>
                                          {{value.label}}
                                      </sc-flex>
                                  </sc-padding>
                              </sc-data-set-tile>
                          </ng-container>
                      </sc-scroll-pane>
                    </sc-flex-fitting-content>
                </sc-flex>
            </sc-flex-fitting-content>
        </sc-flex>
    </div>
</sc-padding>
<sc-separator-line></sc-separator-line>
<sc-padding>
    <sc-flex >
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="cancel()">
            {{'close' | translate: ['tmc-yard.action.close', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="confirm()">
            {{'confirm' | translate: ['tmc-yard.action.confirm', translationService.language]}}
        </button>
    </sc-flex>
</sc-padding>
